import React, { useEffect, useRef, useState } from 'react'
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { constants } from '../../../../misc/constants';
import { BaseConfig } from '../../../BaseConfig';
import PopUp1 from '../../../general/pop-up1';

import "./reference-materials-window.css"
import { AnimationPage } from '../../../../cvp-webgames-core/UI/Animation/animation-page';
import { CustomGameDataConfig, CustomGameDataManager, setFocus, TextHtmlTagType } from '../../../../misc/tools';
import { FontSizeMultiplier } from '../../../../cvp-webgames-core/Misc/interfaces';
import Tools from '../../../../cvp-webgames-core/Misc/Tools';

class ReferenceMaterialsWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'return1',
				src: process.env.PUBLIC_URL + '/assets/images/return1.svg'
			}
		];
	}
}

const referenceMaterials = [{
	prevImg: 'https://s3.amazonaws.com/cdn.creativevet.com/bs-blue-test/assets/images/main-menu/reference-materials/pdf1.png',
	title: 'VA Assault and Harassment Prevention office',
	description: 'The VHA Assault and Harassment Prevention Office supports the Department of Veterans Affairs (VAs) commitment to providing a safe, welcoming, and professional environment for all employees, Veterans, volunteers, and visitors. Harassment or sexual assault will not be tolerated at any VA facility. All who visit a VA campus should expect to be treated with respect. Likewise, we also expect all who enter a VA facility to treat others with respect.',
	src: 'https://www.va.gov/stop-harassment/'
}, {
	prevImg: 'https://s3.amazonaws.com/cdn.creativevet.com/bs-blue-test/assets/images/main-menu/reference-materials/pdf2.png',
	title: 'Bystander Intervention Techniques',
	description: 'Anyone can experience harassment. Sexual harassment is unsolicited verbal or physical contact of a sexual nature that is threatening. Bystander intervention strategies help you to recognize and respond safely to a situation that is potentially hostile or to a behavior that may be harassing so that the situation does not get worse. Any individual who has been subjected to or witnessed unwelcome conduct is encouraged to use these strategies to safely intervene or report unwelcome and offensive conduct.',
	src: 'https://www.va.gov/STOP-HARASSMENT/bystander-intervention-techniques.asp'
}]

export const referenceMaterialsWindowCaching = new ReferenceMaterialsWindowCaching();

const ReferenceMaterialsWindow = (props: ReferenceMaterialsWindowConfig) => {
	const root = useRef(null);
	const [savedData, setSavedData] = useState(null as CustomGameDataConfig)
	const [focusSet, setFocusSet] = useState(false);
	useEffect(() => {
		props.animation.updateProps({
			page: root.current
		});
	}, [root])
	if(!savedData) {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			setSavedData(savedData.data);
		})
		return <div id='reference-window-top' tabIndex={0} ref={root} className={"modal-disable-select center-element reference-materials-window-container " + props.animation.getInitialClass()} style={{
		}}></div>;
	}
	var mapHeight = 0;
	switch (savedData.fontSizeMultiplier) {
		case FontSizeMultiplier.small:
			mapHeight = 400;
			break;
		case FontSizeMultiplier.med:
			mapHeight = 800;
			break;
		case FontSizeMultiplier.big:
			mapHeight = 1200;
			break
	}
	
	if(!focusSet) {
		Tools.getSaveData().then((retrievedData: CustomGameDataManager) => {
			if(retrievedData.data.isAnimationsEnabled) {
				setTimeout(() => {
					setFocus('reference-window-top');
				}, 1000);
			} else {
				setFocus('reference-window-top', null, 50);
			}
			
			setFocusSet(true);
		})
	}
	
	return (
		<div id='reference-window-top' tabIndex={0} ref={root} className={"modal-disable-select center-element reference-materials-window-container " + props.animation.getInitialClass()} style={{
		}}>
			<PopUp1
				title={constants.projectTitle}
				buttons={[{
					imgSrc: referenceMaterialsWindowCaching.getItemByKey('return1').src,
					width: '483px',
					height: '80px',
					buttonText: "Return to Main Menu",
					hoverColor: '#bfddff',
					bgColor: undefined,
					onClick: props.onReturnToMainMenu
				}]}
				onRenderContent={() => {
					return (
						<div style={{ width: '100%', height: '570px', position: 'relative', top: '0', left: '0px' }}>
							<div style={{ margin: '20px', position: 'absolute', left: '0px', top: '0px', width: '97%', height: '540px' }} className='main-content-inner'>
								<div style={{
									marginLeft: '20px',
									marginTop: '20px',
									marginRight: '20px',
									marginBottom: '20px',
									overflow: 'auto',
									height: '498px'
								}}>
									<div>
										<div className='center-element-horizontal white-text' style={{
											textAlign:'center',
											width: '100%'
										}}>
											<h1 className='black-text' style={{fontWeight: 'bold'}}>Reference Materials</h1>
										</div>
									</div>

									{referenceMaterials.map((item: any, indx: number) => {

										return (
											<div tabIndex={0} style={{ position: 'relative', width: '100%', minHeight: '400px' }}>
												<div style={{ width: '50%', position: 'absolute', left: '0px', top: '15px' }}>
													<img src={item.prevImg} aria-label={item.title} alt={item.title + ' - Visit the website to see more.'} />
												</div>
												<div style={{ width: '48%', position: 'relative', left: '570px', paddingBottom: '20px' }}>
													<h2 className="" style={{ color: 'black', textAlign: 'left', fontWeight: 'bold', marginRight: '15px'}}>{item.title}</h2>
													<br />
													<p className="" style={{ color: 'black', textAlign: 'left', marginRight: '15px'}}>{item.description}</p>
													<br />
													<a tabIndex={-1} aria-label="Select this to open the website in a new tab." href={item.src} target="_blank">
														<button className="reference-materials-window-button-text small-text">Select this to open website</button>
													</a>
												</div>
											</div>
										)
									})}

								</div>
								
							</div>
						</div>
					);
				}}></PopUp1>
		</div>
	);

};

export interface ReferenceMaterialsWindowConfig extends BaseConfig {
	onReturnToMainMenu: () => void;
	animation: AnimationPage;
}

export default ReferenceMaterialsWindow;